import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { usePeriscopeActions } from '@hooks';
import React, { useCallback } from 'react';
export const PeriscopeClose = ({ index }) => {
    const { closePeriscope } = usePeriscopeActions();
    const handleClick = useCallback(() => {
        closePeriscope(index);
    }, [closePeriscope, index]);
    return (React.createElement("div", { className: 'periscope-close' },
        React.createElement(Button, { icon: React.createElement(CloseOutlined, null), onClick: handleClick, type: 'link' })));
};
